import React from 'react';
import * as hf from './_hf';
import * as ht from './_ht';

/*
export const useSz = ( // setting
  itlz?: ht.dz,
) => {
  return useDz(itlz);
};
*/

/*
export const usePz = ( // page
  itlz?: ht.dz,
) => {
  const _dz = useDz({
    bUdt: false,
    nIdx: 0, // 廃止予定
    cttType: 'top' as 'top' | 'dtl',
    editMode: 'dpy' as 'crt' | 'udt' | 'dpy' | 'hty',
    tab: '',
    nSort: -1, // 廃止予定
    sort: -1,
    nStep: 0, // 廃止予定
    step: 0,
    ...itlz,
  });
  const _frcUdt = _dz.set({ bUdt: !_dz.crt.bUdt });
  return {
    ... _dz,
    frcUdt: _frcUdt,
  };
};
*/

/*
export const usePz = ( // page
  itlz?: ht.dz,
) => {
  return useDz({
    nIdx: 0, // 廃止予定
    cttType: 'top' as 'top' | 'dtl',
    editMode: 'dpy' as 'crt' | 'udt' | 'dpy' | 'hty',
    tab: '',
    nSort: -1, // 廃止予定
    sort: -1,
    nStep: 0, // 廃止予定
    step: 0,
    ...itlz,
  });
};
*/
export const usePz = ( // page
  itlz?: ht.dz,
) => {
  const _itlz = {
    bUdt: false,
//    cttType: 'top' as 'top' | 'dtl', // 廃止予定
    ctt: 'none', // content r: reserve, e: entry
//    editMode: 'dpy' as 'crt' | 'udt' | 'dpy' | 'hty', // 廃止予定
    phs: 'dpy' as 'crt' | 'udt' | 'dpy' | 'hty', // phase
    role: 'none', // role, k: kanri, s: staff, etc.
    idx: -1,
    sort: -1,
    steps: [0, 0, 0],
    tab: '',
    vsn: -1,
    ... itlz,
  } as ht.dz;
  const _ls = React.useState(_itlz);
  const _clr = () => _ls[1](_itlz);
  const _set = async (pz: ht.dz) => await _ls[1]({ ..._ls[0], ...pz});
  const _rlc = (pz: ht.dz) => _ls[1](pz);
  //const _udt = _set({ bUdt: !_ls[0].bUdt });
  const _udtAll = () => _ls[1]({ ..._ls[0], bUdt: !_ls[0].bUdt });
  return {
    crt: _ls[0],
    clr: _clr,
    set: _set,
    rlc: _rlc,
    udtAll: _udtAll,
    udt: _udtAll, // 廃止予定
  }
};

export const usePagez = usePz; // 廃止予定

export const useDz = (
  itlz?: ht.dz,
) => {
//  const _ls = React.useState(itlz ?? {});
  const _ls = React.useState(itlz ?? {});
  return {
    clr: () => _ls[1]({}),
    crt: _ls[0],
    set: (pz: ht.dz) => _ls[1]({ ..._ls[0], ...pz}),
    rlc: (pz: ht.dz) => _ls[1](pz),
  }
};

export const useLs = (
  pItls?: ht.ls,
) => {
  const _ls = React.useState(pItls ?? []);
  return {
    clr: () => _ls[1]([]),
    crt: _ls[0],
    set: (pLs: ht.ls) => _ls[1](pLs)
  }
};

export const useAny = (
  paItl?: ht.a,
) => {
  const _ls = React.useState(paItl);
  return {
    clr: () => _ls[1](paItl),
    crt: _ls[0],
    set: (paVle: ht.a) => _ls[1](paVle)
  }
};

/*
export const udtThis = () => { // 並行実行される場合、複数使用
  const _ls = React.useState(false);
  return async (_s?: ht.s) => {
    if (_s) hf.l(`csLcl 127: stt ${_s ?? ''}`);
    await _ls[1](!_ls[0]);
    if (_s) hf.l(`csLcl 127: end ${_s ?? ''}`);
  }
};
*/
export const udtThis = () => { // 並行実行される場合、複数使用
  const _ls = React.useState(false);
  let _b1 = true;
  return async (_s?: ht.s) => {
    let _b2 = true;
    while (_b2) {
      if (_b1) {
        _b1 = false;
        if (_s) hf.l(`csLcl 143: stt ${_s ?? ''}`);
        await _ls[1](!_ls[0]);
        if (_s) hf.l(`csLcl 145: end ${_s ?? ''}`);
        _b1 = true;
        _b2 = false;
      }
      else {
        await hf.waitAsync(100);
      }
    }
  }
};
export const frcUdt = udtThis; // 廃止予定